import { useContext } from 'react';
import { DeleteUserModalContext } from './DeleteUserModalContext';

const useDeleteUserModal = () => {
  const { open } = useContext(DeleteUserModalContext);
  return { open };
};

export default useDeleteUserModal;
